import * as React from 'react'
import { Box, Modal, Typography as MIUTypography, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useSelector, useDispatch } from 'react-redux'
import { setOpen } from '../../redux/slices/Modal/modalBoxConfirmation'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  pb: 1,
  filter:
    'drop-shadow(0px 15px 12px rgba(0, 0, 0, 0.22)) drop-shadow(0px 19px 38px rgba(0, 0, 0, 0.3))',
  textAlign: 'justify',
  borderRadius: '14px',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: props.istitle ? '1.2em' : '0.9em',
  fontWeight: props.istitle ? 500 : 400,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#3d3d3d',
}))

const BoxConfirmation = ({
  width = 560,
  title,
  description,
  handleContinue = () => {},
  handleCancel,
}) => {
  const { open } = useSelector(state => state.modalConfirmation)
  const dispatch = useDispatch()

  const handleClose = () => dispatch(setOpen(false))

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        componentsProps={{ backdrop: { sx: { backdropFilter: 'blur(2px)' } } }}
        disableEscapeKeyDown>
        <Box sx={{ ...style, width }}>
          <Typography istitle={1} id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ my: 1 }}>
            {description}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
            {Boolean(handleCancel) && <Button onClick={handleCancel}>Cancelar</Button>}
            <Button onClick={handleContinue}>Continuar</Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}
export default BoxConfirmation
